// extracted by mini-css-extract-plugin
module.exports =  {"label":"LH4epm","color-sample":"VTTzzk","colorSample":"VTTzzk","disabled":"V8COil","input":"Deb51P"};